export default {
  de: {
    add: 'Status hinzufügen',
    categories: 'Kategorien',
    statuses: 'Status',
    name: 'Name',
  },
};
